window.domainFooterTypeFormatter = function(value, row) {
    let html = '';
    switch (row.raw_type) {
        case 'page':
            html += row.page;
            break;
        case 'url':
            html += '<a href="'+row.url+'" target="_blank" rel="noopener noreferrer">';
            html += '<i class="fas fa-external-link"></i>';
            html += '</a>';
            break;
    }
    return html;
}
